@if(!service.router.isFromApp()){
    <div class="information">
        <div>
            <h1 class="font-bold">Manage your payment information</h1>
            <p class="m-0">Your can add or edit your preferred payment method, and delete any payment methods you don't want to use.</p>
        </div>
    </div>
}
@for(card of cards; track card._id){
    <billing-card [card]="card" (remove)="deleteCard($event)"/>
}
<div class="card-section my-10">
    @if(service.auth.userSession()){
        <card-input ngSkipHydration (cardAdded)="onCardAdded($event)"/>
    }
</div>

<a #addcc style="display: none;" [attr.href]="ccurl">
Redirect
</a> 